import { render, staticRenderFns } from "./DeleteArticle.vue?vue&type=template&id=47db5db8"
import script from "./DeleteArticle.vue?vue&type=script&lang=js"
export * from "./DeleteArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports